<template>
  <no-ssr>
    <Drawer
      :title="drawerTitle"
      width="680"
      @on-close="closeMessage"
      :mask-closable="false"
      v-model="visable"
    >
      <spinner v-model="loading"></spinner>
      <skeleton-paragraph v-if="spinnerShow" :lines="9" />
      <div style="height: 100%" v-else>
        <div class="drawer-content" style="margin:auto 40px">
          <Form
            ref="userForm"
            label-position="top"
            :model="userForm"
            :rules="rules"
          >
            <FormItem label="通知标题" prop="noticeTitle">
              <Input
                placeholder="请输入通知标题"
                v-model="userForm.noticeTitle"
                :maxlength="20"
                :disabled="readonly"
              />
            </FormItem>
            <FormItem label="通知类型" prop="noticeType">
              <Select v-model="userForm.noticeType" :disabled="readonly">
                <Option :value="0" label="通知"></Option>
                <Option :value="1" label="紧急通知"></Option>
              </Select>
            </FormItem>
            <FormItem label="通知内容" prop="noticeContent">
              <Input
                v-model="userForm.noticeContent"
                type="textarea"
                :maxlength="500"
                :autosize="{ minRows: 10 }"
                :disabled="readonly"
              />
            </FormItem>
          </Form>
        </div>
        <div class="drawer-footer" v-if="!readonly">
          <Button type="primary" @click="adminSendMessage4Add(0)">保存</Button>
          <Button type="primary" @click="adminSendMessage4Add(1)">发送</Button>
        </div>
      </div>
    </Drawer>
  </no-ssr>
</template>
<script>
import Format from "~/plugins/format.js";
export default {
  // name: "dictionary-item-drawer",
  props: {},
  data() {
    const validateReceiveUserIdList = (rule, value, callback) => {
      let list = this.$refs.orgTree.getCheckedKeys();
      if (list.length > 0) {
        callback();
      } else {
        callback(new Error("请选择人员！"));
      }
    };
    return {
      treeData: [
        {
          title: "parent",
          loading: false,
          children: []
        }
      ],
      message: [],
      readonly: true,
      userForm: {},
      sendUserModal: false,
      visable: false,
      spinnerShow: false,
      loading: false,
      drawerTitle: null,
      orgTree: [],
      rules: {
        noticeTitle: [
          {
            required: true,
            message: "通知标题不能为空",
            trigger: "blur"
          }
        ],
        noticeContent: [
          {
            required: true,
            message: "通知内容不能为空",
            trigger: "blur"
          }
        ],
        receiveUserIdList: [
          {
            required: true,
            validator: validateReceiveUserIdList,
            trigger: "change"
          }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    addMessage() {
      this.drawerTitle = "新建通知消息";
      this.visable = true;
      this.readonly = false;
    },
    editInfo(id) {
      this.drawerTitle = "编辑通知消息";
      this.visable = true;
      this.readonly = false;
      this.getMessageInfo(id);
    },
    viewInfo(id, readStatus) {
      this.drawerTitle = "查看通知消息";
      this.visable = true;
      this.readonly = true;
      this.getMessageInfo(id);
      if (readStatus == 0) {
        this.changeReadStatus(id);
      }
    },
    changeReadStatus(id) {
      this.$store
        .dispatch("stationNotification/changeReadStatus", { id: id })
        .then(res => {});
    },
    getMessageInfo(id) {
      this.loading = true;
      this.$store
        .dispatch("stationNotification/getMessageInfo", { id: id })
        .then(res => {
          this.userForm = res;
          this.loading = false;
        });
    },
    adminSendMessage4Add(num) {
      //新建中保存发送消息
      this.$refs["userForm"].validate(valid => {
        if (valid) {
          this.loading = true;
          let params = { ...this.userForm };
          params.pushStatus = num;
          params.receiveUserIdList = this.$refs.orgTree.getCheckedKeys();
          this.$store
            .dispatch("stationNotification/savePushMessage", params)
            .then(res => {
              this.loading = false;
              this.$emit("tableReload");
              this.$Message.success("操作成功");
              this.visable = false;
            })
            .catch(error => {
              this.loading = false;
              this.$Message.warning(error.message);
            });
        }
      });
    },
    closeMessage() {
      this.userForm = {};
      this.$refs["userForm"].resetFields();
      this.$emit("tableReload");
    }
  }
};
</script>
